<template>
    <div class="table-responsive">
        <base-table thead-classes="thead-light"
                    :data="orders">
            <template slot="columns">
                <th>ID</th>
                <th>{{ $t('order') }}</th>
                <th>{{ $t('sum') }}, {{ $t('cur') }}.</th>
                <th :title="$t('discount_user_promocode')">{{ $t('discount') }}</th>
                <th>{{ $t('order_date') }}</th>
                <th>{{ $t('reward_date') }}</th>
                <th>{{ $t('percent') }}</th>
                <th>{{ $t('sum') }}, {{ $t('cur') }}.</th>
            </template>

            <template slot-scope="{row}">
                <td>{{row.id}}</td>
                <td>{{getType(row)}}</td>
                <td>{{row.price}}</td>
                <td :title="$t('discount_user_promocode')">{{getPromocode(row)}}</td>
                <td>{{row.paydate}}</td>
                <td>{{row.ref_date}}</td>
                <td>{{row.ref_percent}}</td>
                <td>{{row.ref_sum}}</td>
            </template>

        </base-table>
        <div v-if="!orders || orders.length === 0 " class="text-center my-5"> {{ $t('reward_orders_empty') }}</div>
        <div v-if="orders && orders.length > 0 " class="text-center my-5"> {{ $t('reward_total') }}: <strong>{{total | formatPrice}} {{ $t('cur') }}.</strong></div>
    </div>
</template>

<script>
    import numeral from 'numeral';

    export default {
        name: "RefPayed",
        props: {
            orders: {
                type: Array,
                default: function () {
                    return []
                },
            },
        },
        data() {
            return {}
        },
        mounted() {

        },
        computed: {
            total() {
                let sum = 0;
                this.orders.forEach(a => sum += parseFloat(a.ref_sum))
                return sum
            }
        },
        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            }
        },
        methods: {
            getType(order) {
                if (order.idproduct) return this.$t('item_product') + ' #' + order.idproduct;
                if (order.idsubscription)
                    return this.$t('subscription') + ' "' + order.subscription.subscription + '" [' + order.subscription.stype + ']';
                if (order.idcourse)
                    return this.$t('course') + ' "' + order.course.course + '"';
                if (order.idcertcourse) return this.$t('course_certificate') + order.certCourse.course + '"';
                return this.$t('unknown');
            },
            getPromocode(order) {
                if (order.idpromocode) {
                    if (order.promocode.ctype == 2) return order.promocode.discount + "%"
                    if (order.promocode.ctype == 1) return order.promocode.discount + " " + this.$t('cur') + "."
                    return "?"
                } else {
                    return '-';
                }
            },
        }
    }
</script>

<style scoped>

</style>
